import React from 'react';

interface SubscriptionStatusProps {
  subscriptionPlan: string | null;
}

const SubscriptionStatus: React.FC<SubscriptionStatusProps> = ({ subscriptionPlan }) => {
  const getStatusDisplay = () => {
    if (!subscriptionPlan) return { text: 'Inactive', color: 'text-red-500' };
    return { text: "Active", color: 'text-green-600 dark:text-green-500' };
  };

  const status = getStatusDisplay();

  return (
    <div className="flex justify-between items-center mb-4 px-1">
      <p className="text-black dark:text-white">Subscription Status</p>
      <span className={status.color}>{status.text}</span>
    </div>
  );
};

export default SubscriptionStatus;